export function getPercentage(small,total) {
    return `${Math.round((small/total)*100)}%`
}